import { Component, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-info-qr',
  templateUrl: './info-qr.component.html',
  styleUrls: ['./info-qr.component.scss'],
  standalone: false,
})
export class InfoQrComponent implements OnInit {

  constructor(
    public popoverController: PopoverController
  ) { }

  ngOnInit() {}

  infoQrDismiss() {
    this.popoverController.dismiss();
  }
}
